import { useMemo } from 'react';
import { useAccount } from '../../services/settings/hooks/useAccount';
import type { Customer } from './fragments/gql/Customer';

export const useAllCustomers = (options?: { includeClosedCustomers?: boolean }): Customer[] => {
  const settings = useAccount();

  return useMemo(
    () => (settings.customers ?? []).filter(c => options?.includeClosedCustomers || c.isValid),
    [options?.includeClosedCustomers, settings.customers],
  );
};
